package com.devi3east.bashbuddy.features.common.data.api

import Config
import io.ktor.client.HttpClient
import io.ktor.client.plugins.contentnegotiation.ContentNegotiation
import io.ktor.client.plugins.logging.DEFAULT
import io.ktor.client.plugins.logging.LogLevel
import io.ktor.client.plugins.logging.Logger
import io.ktor.client.plugins.logging.Logging
import io.ktor.http.HttpHeaders
import io.ktor.serialization.kotlinx.json.json
import kotlinx.serialization.json.Json

val BASE_URL = if (Config.isProduction) "https://bash-buddy.com" else "http://staging.bash-buddy.com:8081"
// const val BASE_URL_STAGING = "http://staging.bash-buddy.com:8081" // staging

const val SB_BASE_URL = "https://www.themealdb.com/api/json/v1/1/"

val httpClient = HttpClient {
    install(ContentNegotiation) {
        json(
            Json {
                prettyPrint = true
                ignoreUnknownKeys = true
                coerceInputValues = true
            }
        )
    }

    install(Logging) {
        logger = Logger.DEFAULT
        level = LogLevel.ALL
        sanitizeHeader { header -> header == HttpHeaders.Authorization }
    }
}